import React from 'react';
import ReactImageFallback from 'react-image-fallback';
import { LazyLoadComponent } from 'react-lazy-load-image-component';
import loadingGif from 'assets/images/pickapier/loading.svg';
import { ConditionalWrapper } from 'library/helpers/utils';

const imageStyle = {
  width: 30,
  objectFit: 'fill',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  margin: 'auto'
};
const loadingContainerStyle = {
  width: '100%',
  height: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center'
};
const ImageWithFallback = props => {
  const { lazy, ...restProps } = props;

  return (
    <ConditionalWrapper
      condition={lazy}
      wrapper={children => <LazyLoadComponent>{children}</LazyLoadComponent>}
    >
      <ReactImageFallback
        {...restProps}
        fallbackImage={
          <div style={loadingContainerStyle}>
            <img style={imageStyle} src={loadingGif} />
          </div>
        }
        initialImage={
          <div style={loadingContainerStyle}>
            <img style={imageStyle} src={loadingGif} />
          </div>
        }
      />
    </ConditionalWrapper>
  );
};

export default ImageWithFallback;
